import React from 'react'
import { Box, LinearProgress, Typography } from '@mui/material'
import type { ThemeAIRun } from '../../types/gotypes'
import { themeAIRunProgress } from '../../utils/themeAIRunProgress'

interface RunProgressProps {
  run?: ThemeAIRun
  /** What is being coded, for the line above the bar. */
  label: string
}

// A run or test in flight, with how far it has got (Matt, 21 Sep: "if there's
// 1,045, you need to know it's done 422"). One bar for the whole run that only
// moves forward; the line under it names the phase and its batches.
const RunProgress: React.FC<RunProgressProps> = ({ run, label }) => {
  const { percent, phase, detail } = themeAIRunProgress(run)
  const known = percent !== undefined

  return (
    <Box sx={{ maxWidth: 560 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 2, mb: 1 }}>
        <Typography variant="body2">{label}</Typography>
        {known && (
          <Typography variant="body2" color="text.secondary" sx={{ fontVariantNumeric: 'tabular-nums' }}>
            {percent}%
          </Typography>
        )}
      </Box>
      <LinearProgress
        color="info"
        variant={known ? 'determinate' : 'indeterminate'}
        value={percent ?? 0}
        aria-label={known ? `${percent}% done` : 'Coding responses'}
      />
      {(phase || detail) && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, fontVariantNumeric: 'tabular-nums' }}>
          {[phase, detail].filter(Boolean).join(' · ')}
        </Typography>
      )}
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: phase || detail ? 0.5 : 1 }}>
        You can leave this page. It carries on, and the results are here when you come back.
      </Typography>
    </Box>
  )
}

export default RunProgress
